import { fork, take, call, put } from 'redux-saga/effects';

import authService from 'services/authService';

import { types, resetPassword } from './actions';

function* watchResetPassword() {
  for (;;) {
    try {
      const action = yield take(types.RESET_PASSWORD_REQUEST);
      const response = yield call(
        authService.resetPassword,
        action.payload.data,
      );
      yield put(resetPassword.success(response));
    } catch (error) {
      yield put(resetPassword.error(error));
    }
  }
}

export default function* root() {
  yield fork(watchResetPassword);
}
